import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { CreateQueryModal } from "./CreateQueryModal";
import { QueriesList } from "./QueriesList";
import { QueryDetail } from "./QueryDetail";
import { StatsCards } from "./StatsCards";
import { AccountType } from "../../../models/AccountData";
import { OptionalRender } from "../../Common/OptionalRender";

import "./styles.scss";

export const GooglePlacesSearchTab: React.FunctionComponent = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`internalToolsHomePage.gbp_places_query.${key}`);

  const [selectedQueryId, setSelectedQueryId] = useState<string | undefined>();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <div className="google-places-search-tab">
      <OptionalRender mustBeOneOfRoles={[AccountType.ADMIN]}>
        {selectedQueryId ? (
          <QueryDetail
            queryId={selectedQueryId}
            onBack={() => setSelectedQueryId(undefined)}
          />
        ) : (
          <>
            <div className="google-places-search-tab-header">
              <div>
                <h2>{t("page.title")}</h2>
                <p>{t("page.subtitle")}</p>
              </div>
              <button
                type="button"
                className="btn btn-blue"
                onClick={() => setIsCreateModalOpen(true)}
              >
                {t("page.create_button")}
              </button>
            </div>
            <StatsCards />
            <QueriesList onSelectQuery={setSelectedQueryId} />
            {isCreateModalOpen && (
              <CreateQueryModal onClose={() => setIsCreateModalOpen(false)} />
            )}
          </>
        )}
      </OptionalRender>
      <OptionalRender mustNotBeRoles={[AccountType.ADMIN]}>
        <p className="google-places-search-tab-access-denied">
          {t("access_denied")}
        </p>
      </OptionalRender>
    </div>
  );
};

export default GooglePlacesSearchTab;
